export default {
  zh: {
    titleText: 'Search room & user',
    enterID: 'uid or roomid',
    find: 'Find',
    userText: 'User',
    roomText: 'Room',
    notFound: 'Not Found',
    webLink: 'Web link'
  },
  en: {
    titleText: 'Search room & user',
    enterID: 'uid & roomid',
    find: 'Find',
    userText: 'User',
    roomText: 'Room',
    notFound: 'Not Found',
    webLink: 'Web link'
  },
  ar: {
    titleText: 'بحث الغرف والمستخدم',
    enterID: 'أيدي الحساب و أيدي المغرفة',
    find: 'وجد',
    userText: 'مستخدم',
    roomText: 'غرفة',
    notFound: 'غير متوفر',
    webLink: 'Web link'
  },
  tr: {
    titleText: 'Oda ve Kullanıcı ara',
    enterID: 'Kullanıcı id ve Oda id',
    find: 'Bul',
    userText: 'kullanıcı',
    roomText: 'oda',
    notFound: 'Bulunamadı',
    webLink: 'Web link'
  },
  pt: {
    titleText: 'Pesquisar sala e usuário',
    enterID: 'uid e roomid',
    find: 'Encontrar',
    userText: 'Usuário',
    roomText: 'Sala',
    notFound: 'Não encontrado',
    webLink: 'Link da web'
  },
  id: {
    titleText: 'Cari ruangan & pengguna',
    enterID: 'uid & roomid',
    find: 'Cari',
    userText: 'Pengguna',
    roomText: 'Ruangan',
    notFound: 'Tidak Ditemukan',
    webLink: 'Tautan web'
  },
  uz: {
    titleText: 'Xona va foydalanuvchini qidirish',
    enterID: 'uid va roomid',
    find: 'Topish',
    userText: 'Foydalanuvchi',
    roomText: 'Xona',
    notFound: 'Topilmadi',
    webLink: 'Veb havola'
  },
  ru: {
    titleText: 'Поиск комнаты и пользователя',
    enterID: 'uid и roomid',
    find: 'Найти',
    userText: 'Пользователь',
    roomText: 'Комната',
    notFound: 'Не найдено',
    webLink: 'Веб-ссылка'
  },
  fa: {
    titleText: 'جستجوی اتاق و کاربر',
    enterID: 'uid و roomid',
    find: 'یافتن',
    userText: 'کاربر',
    roomText: 'اتاق',
    notFound: 'یافت نشد',
    webLink: 'لینک وب'
  }
}



// WEBPACK FOOTER //
// src/pages/admin-control/admin-control-panel/lang.js